// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select_container{margin:10px;display:flex;flex-direction:column;width:250px}.select_label{margin-bottom:10px}.select_error{margin-top:10px;font-size:13px;color:rgba(255,0,0,0.616);font-style:italic}.select_select{background-color:#f8f8f8;border-radius:2.5px;border:1px solid #dadada;padding:10px 8px 10px 8px;width:100%}.select_select:focus{box-shadow:0 0 1pt 1pt #0d1be04d;border:1px solid #0d1be04d;outline:none}.select_select_disabled{opacity:0.5;pointer-events:none}\n", ""]);
// Exports
module.exports = exports;
